import React, { Component } from "react";
import { AiImageModel, DEFAULT_AI_IMAGEMODEL } from "../../../../common/aiConstants";
import { Dropdown } from "../../../Components/Dropdown";
import { MenuItem } from "../../../Components/Menu";

const ImageModels = [{
    label: "Flux Schnell", value: AiImageModel.FLUX_SCHNELL,
}, {
    label: "Flux Fast", value: AiImageModel.FLUX_FAST,
}, {
    label: "Flux Klein", value: AiImageModel.FLUX_KLEIN,
}, {
    label: "Imagen 4 Fast", value: AiImageModel.IMAGEN_4_FAST
}];

export class AiImageModelPicker extends Component {
    render() {
        const { imageModel = DEFAULT_AI_IMAGEMODEL, onChange } = this.props;

        return (
            <Dropdown value={imageModel}
                onChange={imageModel => onChange(imageModel)}
            >
                {ImageModels.map((modelOption, idx) => (
                    <MenuItem key={idx} value={modelOption.value}>{modelOption.label}</MenuItem>
                ))}
            </Dropdown>
        );
    }
}

